/** @format */

import { reducerDebug } from '../../core/debug';

export type rateSchemasReducersType = {
    type?: string;
    collections?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const rateSchemasConstants = {
    LIST: 'rate_schemas_list',
    ITEM: 'rate_schemas_item',
    EDIT: 'rate_schemas_edit',
    DELETE: 'rate_schemas_delete',
    MANAGE: 'rate_schemas_manage',
    ADD: 'rate_schemas_add',
};

export function rateSchemasReducers(state = {}, action: rateSchemasReducersType): object {
    reducerDebug('Prefixes reducer: ' + action.type);
    switch (action.type) {
        case rateSchemasConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case rateSchemasConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case rateSchemasConstants.ADD:
        case rateSchemasConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case rateSchemasConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        default:
            return state;
    }
}
